import { logger } from '@src/utils/misc/logger';
import apptracker from '@src/utils/sensor/apptracker';
import { NEXA_DASHBOARD_LINK_CLICK } from '@src/utils/sensor/track';
import { HandlerOptions } from './types';

/**
 * Handles handle_ai_alerts tool - opens ai alerts dashboard in a new tab
 */
export const handleAiAlerts = (options: HandlerOptions): void => {
  try {
    const { args, baseUrl } = options;
    const { mode } = args || {};

    if (!mode) {
      logger.error('Missing required mode for ai alerts', { args });
      return;
    }

    const { alertIds } = args || {};

    if (mode === 'diagnose' && !alertIds) {
      logger.error('Missing required alertIds for ai alerts', { args });
      return;
    }

    const showSummaryDashboard = (mode === 'diagnose' && alertIds.length > 1) || mode === 'list';
    const url = showSummaryDashboard
      ? `${baseUrl}/dashboard/ai-alerts`
      : `${baseUrl}/dashboard/ai-alerts/pre-app-diagnostics/${alertIds[0]}`;
    if (url) {
      window.open(url, '_blank');
      apptracker(NEXA_DASHBOARD_LINK_CLICK, { type: 'ai_alerts', url });
      logger.log('Opened ai alerts in new tab:', url);
    }
  } catch (error) {
    logger.error('Error handling ai alerts:', error);
  }
};
